import { Box, styled } from '@mui/material';

export const AppointmentDetailsItem = styled('div')({
  display: 'flex',
  flexDirection: 'column'
});

export const AppointmentDateWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginRight: '15px'
});

export const AppointmentDate = styled(Box)({
  fontWeight: 500
});
